import React from 'react'
import { Icon } from './styles'

const DefaultScoreIcon = ({ active, ...otherProps }) =>
  active ? (
    <Icon name="star" {...otherProps} active />
  ) : (
    <Icon name="stroked-star" {...otherProps} />
  )

export default DefaultScoreIcon
